var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import DataBox from '~/components/common/data-box.vue';
import DataForm from '~/components/common/data-form.vue';
import { PageService } from '~/utils/page.service';
import { Dependencies, Layout } from "~/core/decorator";
import { MENU_CHANNEL } from '../../config/enum.config';
import { State } from "vuex-class";
import { TurnRecordService } from '~/services/domain-service/turn-record.service';
var CaseReturnQuery = /** @class */ (function (_super) {
    __extends(CaseReturnQuery, _super);
    function CaseReturnQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            caseNumber: '',
            batchNumber: '',
            principalId: '',
            personalName: '',
            idCard: '',
            loanDate: [],
            mobileNo: '',
            partnerName: '',
            bankName: '',
            caseType: '',
            triggerAction: '',
            caseTurnTime: [],
            name: '',
            operatorRealName: ''
        };
        _this.dataSet = [];
        return _this;
    }
    CaseReturnQuery.prototype.handleResetForm = function () { };
    CaseReturnQuery.prototype.refreshData = function () {
        var _this = this;
        var params = __assign({}, this.dataForm);
        params.caseTurnTimeStart = this.dataForm.caseTurnTime && this.dataForm.caseTurnTime.length ? this.$filter.dateTimeFormat(this.dataForm.caseTurnTime[0]) : '';
        params.caseTurnTimeEnd = this.dataForm.caseTurnTime && this.dataForm.caseTurnTime.length ? this.$filter.dateTimeFormat(this.dataForm.caseTurnTime[1]) : '';
        params.loanDateStart = this.$filter.dateRanageFormat(this.dataForm.loanDate).start;
        params.loanDateEnd = this.$filter.dateRanageFormat(this.dataForm.loanDate).end;
        delete params.caseTurnTime;
        delete params.loanDate;
        this.turnRecordService.findAllTurnRecord(params, this.pageService).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    CaseReturnQuery.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Case_return_query,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    CaseReturnQuery.prototype.created = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], CaseReturnQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(TurnRecordService)
    ], CaseReturnQuery.prototype, "turnRecordService", void 0);
    __decorate([
        State
    ], CaseReturnQuery.prototype, "principalList", void 0);
    CaseReturnQuery = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm
            }
        })
    ], CaseReturnQuery);
    return CaseReturnQuery;
}(Vue));
export default CaseReturnQuery;
